import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyDoCfu89xOPiVDQDtl7I2RIAlptcXfPO5Y",
  authDomain: "tamutrip-e5d5f.firebaseapp.com",
  projectId: "tamutrip-e5d5f",
  storageBucket: "tamutrip-e5d5f.firebasestorage.app",
  messagingSenderId: "377299980124",
  appId: "1:377299980124:web:577c52df936766cdea3b99"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app);
export default app;
